// src/signals/customer-travel-advisory-hide-signal.ts
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { Signal } from "@shared-ui/core-signal-manager/spi";
var CustomerTravelAdvisoryHideSignal = /*#__PURE__*/ function(Signal) {
    "use strict";
    _inherits(CustomerTravelAdvisoryHideSignal, Signal);
    var _super = _create_super(CustomerTravelAdvisoryHideSignal);
    function CustomerTravelAdvisoryHideSignal() {
        _class_call_check(this, CustomerTravelAdvisoryHideSignal);
        return _super.apply(this, arguments);
    }
    return CustomerTravelAdvisoryHideSignal;
}(Signal);
// src/signals/customer-error-message-booking-validation-successful-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageBookingValidationSuccessfulSignal = /*#__PURE__*/ function(Signal2) {
    "use strict";
    _inherits(CustomerErrorMessageBookingValidationSuccessfulSignal, Signal2);
    var _super = _create_super(CustomerErrorMessageBookingValidationSuccessfulSignal);
    function CustomerErrorMessageBookingValidationSuccessfulSignal() {
        _class_call_check(this, CustomerErrorMessageBookingValidationSuccessfulSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageBookingValidationSuccessfulSignal;
}(Signal2);
// src/signals/customer-error-message-clear-error-message-signal.ts
import { Signal as Signal3 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageClearErrorMessageSignal = /*#__PURE__*/ function(Signal3) {
    "use strict";
    _inherits(CustomerErrorMessageClearErrorMessageSignal, Signal3);
    var _super = _create_super(CustomerErrorMessageClearErrorMessageSignal);
    function CustomerErrorMessageClearErrorMessageSignal() {
        _class_call_check(this, CustomerErrorMessageClearErrorMessageSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageClearErrorMessageSignal;
}(Signal3);
// src/signals/customer-error-message-display-signal.ts
import { Signal as Signal4 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageDisplaySignal = /*#__PURE__*/ function(Signal4) {
    "use strict";
    _inherits(CustomerErrorMessageDisplaySignal, Signal4);
    var _super = _create_super(CustomerErrorMessageDisplaySignal);
    function CustomerErrorMessageDisplaySignal() {
        _class_call_check(this, CustomerErrorMessageDisplaySignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageDisplaySignal;
}(Signal4);
// src/signals/customer-error-message-generic-downstream-error-signal.ts
import { Signal as Signal5 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageGenericDownstreamErrorSignal = /*#__PURE__*/ function(Signal5) {
    "use strict";
    _inherits(CustomerErrorMessageGenericDownstreamErrorSignal, Signal5);
    var _super = _create_super(CustomerErrorMessageGenericDownstreamErrorSignal);
    function CustomerErrorMessageGenericDownstreamErrorSignal() {
        _class_call_check(this, CustomerErrorMessageGenericDownstreamErrorSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageGenericDownstreamErrorSignal;
}(Signal5);
// src/signals/customer-error-message-generic-technical-error-signal.ts
import { Signal as Signal6 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageGenericTechnicalErrorSignal = /*#__PURE__*/ function(Signal6) {
    "use strict";
    _inherits(CustomerErrorMessageGenericTechnicalErrorSignal, Signal6);
    var _super = _create_super(CustomerErrorMessageGenericTechnicalErrorSignal);
    function CustomerErrorMessageGenericTechnicalErrorSignal() {
        _class_call_check(this, CustomerErrorMessageGenericTechnicalErrorSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageGenericTechnicalErrorSignal;
}(Signal6);
// src/signals/customer-error-message-gift-card-operation-error-signal.ts
import { Signal as Signal7 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageGiftCardOperationErrorSignal = /*#__PURE__*/ function(Signal7) {
    "use strict";
    _inherits(CustomerErrorMessageGiftCardOperationErrorSignal, Signal7);
    var _super = _create_super(CustomerErrorMessageGiftCardOperationErrorSignal);
    function CustomerErrorMessageGiftCardOperationErrorSignal() {
        _class_call_check(this, CustomerErrorMessageGiftCardOperationErrorSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageGiftCardOperationErrorSignal;
}(Signal7);
// src/signals/customer-error-message-invalid-email-signal.ts
import { Signal as Signal8 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageInvalidEmailSignal = /*#__PURE__*/ function(Signal8) {
    "use strict";
    _inherits(CustomerErrorMessageInvalidEmailSignal, Signal8);
    var _super = _create_super(CustomerErrorMessageInvalidEmailSignal);
    function CustomerErrorMessageInvalidEmailSignal() {
        _class_call_check(this, CustomerErrorMessageInvalidEmailSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageInvalidEmailSignal;
}(Signal8);
// src/signals/customer-error-message-offer-unavailable-signal.ts
import { Signal as Signal9 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageOfferUnavailableSignal = /*#__PURE__*/ function(Signal9) {
    "use strict";
    _inherits(CustomerErrorMessageOfferUnavailableSignal, Signal9);
    var _super = _create_super(CustomerErrorMessageOfferUnavailableSignal);
    function CustomerErrorMessageOfferUnavailableSignal() {
        _class_call_check(this, CustomerErrorMessageOfferUnavailableSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageOfferUnavailableSignal;
}(Signal9);
// src/signals/customer-error-message-one-key-cash-application-failed-signal.ts
import { Signal as Signal10 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageOneKeyCashApplicationFailedSignal = /*#__PURE__*/ function(Signal10) {
    "use strict";
    _inherits(CustomerErrorMessageOneKeyCashApplicationFailedSignal, Signal10);
    var _super = _create_super(CustomerErrorMessageOneKeyCashApplicationFailedSignal);
    function CustomerErrorMessageOneKeyCashApplicationFailedSignal() {
        _class_call_check(this, CustomerErrorMessageOneKeyCashApplicationFailedSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageOneKeyCashApplicationFailedSignal;
}(Signal10);
// src/signals/customer-error-message-one-key-cash-removal-failed-signal.ts
import { Signal as Signal11 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageOneKeyCashRemovalFailedSignal = /*#__PURE__*/ function(Signal11) {
    "use strict";
    _inherits(CustomerErrorMessageOneKeyCashRemovalFailedSignal, Signal11);
    var _super = _create_super(CustomerErrorMessageOneKeyCashRemovalFailedSignal);
    function CustomerErrorMessageOneKeyCashRemovalFailedSignal() {
        _class_call_check(this, CustomerErrorMessageOneKeyCashRemovalFailedSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageOneKeyCashRemovalFailedSignal;
}(Signal11);
// src/signals/customer-error-message-operation-failed-signal.ts
import { Signal as Signal12 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageOperationFailedSignal = /*#__PURE__*/ function(Signal12) {
    "use strict";
    _inherits(CustomerErrorMessageOperationFailedSignal, Signal12);
    var _super = _create_super(CustomerErrorMessageOperationFailedSignal);
    function CustomerErrorMessageOperationFailedSignal() {
        _class_call_check(this, CustomerErrorMessageOperationFailedSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageOperationFailedSignal;
}(Signal12);
// src/signals/customer-error-message-payment-error-signal.ts
import { Signal as Signal13 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessagePaymentErrorSignal = /*#__PURE__*/ function(Signal13) {
    "use strict";
    _inherits(CustomerErrorMessagePaymentErrorSignal, Signal13);
    var _super = _create_super(CustomerErrorMessagePaymentErrorSignal);
    function CustomerErrorMessagePaymentErrorSignal() {
        _class_call_check(this, CustomerErrorMessagePaymentErrorSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessagePaymentErrorSignal;
}(Signal13);
// src/signals/customer-error-message-price-changed-signal.ts
import { Signal as Signal14 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessagePriceChangedSignal = /*#__PURE__*/ function(Signal14) {
    "use strict";
    _inherits(CustomerErrorMessagePriceChangedSignal, Signal14);
    var _super = _create_super(CustomerErrorMessagePriceChangedSignal);
    function CustomerErrorMessagePriceChangedSignal() {
        _class_call_check(this, CustomerErrorMessagePriceChangedSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessagePriceChangedSignal;
}(Signal14);
// src/signals/customer-error-message-promotions-changed-signal.ts
import { Signal as Signal15 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessagePromotionsChangedSignal = /*#__PURE__*/ function(Signal15) {
    "use strict";
    _inherits(CustomerErrorMessagePromotionsChangedSignal, Signal15);
    var _super = _create_super(CustomerErrorMessagePromotionsChangedSignal);
    function CustomerErrorMessagePromotionsChangedSignal() {
        _class_call_check(this, CustomerErrorMessagePromotionsChangedSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessagePromotionsChangedSignal;
}(Signal15);
// src/signals/customer-error-message-scroll-page-request-signal.ts
import { Signal as Signal16 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageScrollPageRequestSignal = /*#__PURE__*/ function(Signal16) {
    "use strict";
    _inherits(CustomerErrorMessageScrollPageRequestSignal, Signal16);
    var _super = _create_super(CustomerErrorMessageScrollPageRequestSignal);
    function CustomerErrorMessageScrollPageRequestSignal() {
        _class_call_check(this, CustomerErrorMessageScrollPageRequestSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageScrollPageRequestSignal;
}(Signal16);
// src/signals/customer-error-message-server-side-error-signal.ts
import { Signal as Signal17 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageServerSideErrorSignal = /*#__PURE__*/ function(Signal17) {
    "use strict";
    _inherits(CustomerErrorMessageServerSideErrorSignal, Signal17);
    var _super = _create_super(CustomerErrorMessageServerSideErrorSignal);
    function CustomerErrorMessageServerSideErrorSignal() {
        _class_call_check(this, CustomerErrorMessageServerSideErrorSignal);
        return _super.apply(this, arguments);
    }
    return CustomerErrorMessageServerSideErrorSignal;
}(Signal17);
export { CustomerErrorMessageBookingValidationSuccessfulSignal, CustomerErrorMessageClearErrorMessageSignal, CustomerErrorMessageDisplaySignal, CustomerErrorMessageGenericDownstreamErrorSignal, CustomerErrorMessageGenericTechnicalErrorSignal, CustomerErrorMessageGiftCardOperationErrorSignal, CustomerErrorMessageInvalidEmailSignal, CustomerErrorMessageOfferUnavailableSignal, CustomerErrorMessageOneKeyCashApplicationFailedSignal, CustomerErrorMessageOneKeyCashRemovalFailedSignal, CustomerErrorMessageOperationFailedSignal, CustomerErrorMessagePaymentErrorSignal, CustomerErrorMessagePriceChangedSignal, CustomerErrorMessagePromotionsChangedSignal, CustomerErrorMessageScrollPageRequestSignal, CustomerErrorMessageServerSideErrorSignal, CustomerTravelAdvisoryHideSignal };
//# sourceMappingURL=index.js.map